import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

// Transient statuses worth retrying (network failure + gateway errors)
const RETRYABLE_STATUSES = [0, 502, 503, 504];
const MAX_RETRIES = 2;

/**
 * Attaches the Bearer token and handles exponential-backoff retry for
 * idempotent transient errors. 401/403 handling is left to error.interceptor.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    retry({
      count: MAX_RETRIES,
      delay: (err: HttpErrorResponse, retryCount) => {
        // Only retry GET/HEAD — never retry mutations to avoid duplicate writes
        const isSafeMethod = req.method === 'GET' || req.method === 'HEAD';
        if (!isSafeMethod || !RETRYABLE_STATUSES.includes(err.status)) {
          return throwError(() => err);
        }
        // Exponential backoff: 500ms, 1000ms (with ±100ms jitter)
        const delayMs = Math.pow(2, retryCount - 1) * 500 + Math.random() * 100;
        return timer(delayMs);
      }
    })
  );
};

